import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import "./styles.css";
import "./styles/crm-redesign.css";
import "./styles/workspace.css";

document.documentElement.dataset.theme = "light";
document.documentElement.style.colorScheme = "light";

const root = document.getElementById("root");
if (!root) throw new Error("No se encontró el contenedor principal.");

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
